import { GetTreatyClaim, GetTreatyClaimVariables } from "_graphql/queries/__generated__/GetTreatyClaim";
import { GetTreatyClaimShare, GetTreatyClaimShareVariables } from "_graphql/queries/__generated__/GetTreatyClaimShare";
import { GetTreatyClaimShares, GetTreatyClaimSharesVariables } from "_graphql/queries/__generated__/GetTreatyClaimShares";
import { GetTreatyClaims, GetTreatyClaimsVariables } from "_graphql/queries/__generated__/GetTreatyClaims";
import { getTreatyClaim, getTreatyClaimShare, getTreatyClaimShares, getTreatyClaims } from "_graphql/visal/queries/treaty-claims";

import { useQuery } from "@apollo/client";

export const useTreatyClaims = (variables?: GetTreatyClaimsVariables) => {
    const { data, ...rest } = useQuery<GetTreatyClaims, GetTreatyClaimsVariables>(getTreatyClaims, {
        variables,
        fetchPolicy: "network-only",
        notifyOnNetworkStatusChange: true,
    });

    return {
        claims: data?.getTreatyClaims || [],
        count: data?.getTreatyClaimsCount || 0,
        ...rest,
    }
}

export const useTreatyClaim = (variables?: GetTreatyClaimVariables) => {
    const { data, ...rest } = useQuery<GetTreatyClaim, GetTreatyClaimVariables>(getTreatyClaim, {
        variables,
        fetchPolicy: "network-only",
        notifyOnNetworkStatusChange: true,
    });

    return {
        claim: data?.getTreatyClaim,
        ...rest,
    }
}

export const useTreatyClaimShares = (variables?: GetTreatyClaimSharesVariables) => {
    const { data, ...rest } = useQuery<GetTreatyClaimShares, GetTreatyClaimSharesVariables>(getTreatyClaimShares, {
        variables,
        fetchPolicy: "network-only",
        notifyOnNetworkStatusChange: true,
    });

    return {
        shares: data?.getTreatyClaimShares || [],
        ...rest,
    }
}

export const useTreatyClaimShare = (variables?: GetTreatyClaimShareVariables) => {
    const { data, ...rest } = useQuery<GetTreatyClaimShare, GetTreatyClaimShareVariables>(getTreatyClaimShare, {
        variables,
        fetchPolicy: "network-only",
        notifyOnNetworkStatusChange: true,
    });

    return {
        share: data?.getTreatyClaimShare,
        ...rest,
    }
}